export const GTM_ID = import.meta.env.VITE_GTM_ID
export const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_ID
